import React from 'react';
import styled from 'styled-components';
import { Box } from '../../primitives/Box/Box.es.js';
import '../../primitives/Center/styled.es.js';
import '../../primitives/Group/Group.es.js';
import '../../primitives/Grid/Grid.es.js';
import '../../primitives/Level/Level.es.js';
import '../../primitives/Shelf/Shelf.es.js';
import '../../primitives/Portal/Portal.es.js';
import '../../primitives/Hidden/Hidden.es.js';
import '../../primitives/Media/Media.es.js';
import '../../primitives/Dialog/Dialog.es.js';
import '../../primitives/VisuallyHidden/VisuallyHidden.es.js';
import '../../primitives/TruncateByCharacters/TruncateByCharacters.es.js';
import '../../primitives/TruncateByLines/TruncateByLines.es.js';
import 'react-transition-group';
import '../../primitives/Popper/Popper.es.js';
import '../../primitives/DragHandle/DragHandle.es.js';
import '../../primitives/Pin/Pin.es.js';
var StyledTopBar = styled(Box).withConfig({
  componentId: "j6ncsd-0"
})(["flex:0 0 auto;"]);
var StyledHeader = styled(Box).withConfig({
  componentId: "j6ncsd-1"
})(["flex:0 0 auto;"]);
var StyledContent = styled(Box).withConfig({
  componentId: "j6ncsd-2"
})(["flex:1 1 auto;"]);
var StyledFooter = styled(Box).withConfig({
  componentId: "j6ncsd-3"
})(["flex:0 0 auto;margin-top:auto;"]);
var StyledSiteLayout = styled.div.withConfig({
  componentId: "j6ncsd-4"
})(["display:flex;flex-direction:column;width:100%;max-width:100vw;min-height:100%;"]);

var SiteLayout = function SiteLayout(_ref) {
  var children = _ref.children;
  return (
    /* @__PURE__ */
    React.createElement(StyledSiteLayout, null, children)
  );
};

SiteLayout.TopBar = StyledTopBar;
SiteLayout.Header = StyledHeader;
SiteLayout.Content = StyledContent;
SiteLayout.Footer = StyledFooter;
SiteLayout.displayName = "SiteLayout";
export { SiteLayout };